import type { Editor } from 'grapesjs';

const styleManagerLabelsOverride = {
  en: {
    styleManager: {
      properties: {
        color: 'Text color',
        'font-size': 'Text size',
        'font-weight': 'Text weight',
        'line-height': 'Line spacing',
        'letter-spacing': 'Letter spacing',
        'text-align': 'Text alignment',
        'justify-content': 'Horizontal alignment',
        'align-items': 'Vertical alignment',
        display: 'Item Layout',
        gap: 'Space Between',
        'flex-wrap': 'Content Wrap',
        order: 'Item Order',
        'align-self': 'Alignment',
        padding: 'Inside Padding',
        margin: 'Outside Padding',
        'vertical-align': 'Vertical text Alignment',
        'text-transform': 'Case',
        'text-decoration': 'Line decor',
        'white-space': 'Wrap Text',
        background: 'Background image',
        'background-clip': 'Background Fill',
      },
      layout: {
        flexChild: 'Item Layout',
        display: {
          tips: {
            block: 'Items go one under another, top to bottom.',
            inline: 'Items go next to each other in one line.',
            'inline-block': 'Items go next to each other, and you can change how big each one is.',
            flex: 'Use a flexible layout that automatically arranges and aligns items inside this block.',
            none: 'Items stay exactly where they are.',
          },
        },
      },
      options: {
        display: {
          block: 'Stacked',
          inline: 'Inline',
          'inline-block': 'Inline (Resizable)',
          flex: 'Flex',
          none: 'No layout',
        },
        position: {
          absolute: 'Custom Placement',
          static: 'Normal',
          relative: 'Nudge',
          fixed: 'Always Visible',
          sticky: 'Scroll & Stick',
        },
        'white-space': {
          pre: 'Exact Spacing',
          'pre-wrap': 'Wrap with spacing',
          'pre-line': 'Wrap on line breaks',
          'break-spaces': 'Break anywhere',
        },
        'background-clip': {
          'border-box': 'Fill entire block',
          'padding-box': 'Fill inside padding',
          'content-box': 'Fill only content',
          text: 'Fill behind text',
        },
      },
      position: {
        tips: {
          static: 'The item stays in its normal spot.',
          relative: 'Move the item a little without breaking the layout.',
          absolute: 'Place the item anywhere on the page.',
          fixed: 'The item stays visible while you scroll.',
          sticky: 'The item scrolls, then sticks in place.',
        },
      },
    },
  },
};

/**
 * Applies custom Style Manager (and related) i18n labels to the GrapesJS editor.
 */
export function applyLabelsOverride(editor: Editor): void {
  editor.I18n.addMessages(styleManagerLabelsOverride);
}
